module.exports = __webpack_public_path__ + "img/less-than.6761bea3.svg";